import { useQuery } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
export interface FAQ {
  id: number;
  category: string;
  question: string;
  answer: string;
}
export const fetchFaqs = async (category?: string): Promise<FAQ[]> => {
  const url = category ? `${API_ENDPOINTS.FAQS}?category=${encodeURIComponent(category)}` : API_ENDPOINTS.FAQS;
  const {
    data
  } = await http.get(url);
  return data;
};
export const useFaqsQuery = (category?: string) => {
  return useQuery<FAQ[], Error>(['faq/faq', category], () => fetchFaqs(category), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true
  });
};
export const fetchRecentFaqs = async (): Promise<FAQ[]> => {
  const {
    data
  } = await http.get(API_ENDPOINTS.FAQS);
  return data.slice(0, 5);
};
export const useRecentFaqsQuery = () => {
  return useQuery<FAQ[], Error>(['faq/faq', 'recent'], fetchRecentFaqs, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    staleTime: 15 * 60 * 1000,
    cacheTime: 15 * 60 * 1000
  });
};